import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { initConsoleCapture } from './utils/consoleCapture';
import { installPreloadErrorHandler } from './core/chunkReload';

// Round 57, A2/B — must start before anything else has a chance to log, so
// the problem reporter's console attachment reflects the whole session.
initConsoleCapture();
// Round 132b (A): a lazy chunk that vanished in a deploy -> one automatic reload on the same route (core/chunkReload.ts)
installPreloadErrorHandler();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
